<template>
  <input-text-modal
    :title="$t('explorer.queryModal.title')"
    v-if="showInputTextModal"
    v-model="queryName"
    :error="showInputTextModalError"
    :errorMessage="$t('explorer.queryModal.queryNameError')"
    :okButton="$t('commons.save')"
    :label="$t('explorer.queryModal.queryName')"
    v-on:cancel="showInputTextModal = false"
    v-on:ok="emitSave">
    <div
      slot="extra">
      <checkbox
        id="queryWithDatesCheckBox"
        :label="$t('explorer.queryModal.checkboxLabel')"
        v-on:change="onQueryWithDatesChanged"
        :checked="queryWithDates">
      </checkbox>
      <InlineTip
        :title="$t('explorer.queryModal.tooltipTitle')"
        :desc="$t('explorer.queryModal.tooltipDescription')"/>
    </div>
  </input-text-modal>
</template>

<script>
import InputTextModal from '@/components/shared/dialogs/InputTextModal';
import Checkbox from '@/components/shared/forms/Checkbox';
import InlineTip from '@/components/explorer/InlineTip';

export default {
  components: {
    InputTextModal,
    Checkbox,
    InlineTip
  },
  data () {
    return {
      queryName: '',
      queryWithDates: false,
      showInputTextModal: false,
      showInputTextModalError: false
    };
  },
  methods: {
    show () {
      this.queryName = '';
      this.queryWithDates = false;
      this.showInputTextModal = true;
      this.showInputTextModalError = false;
    },
    emitSave () {
      if (this.queryName.length > 0) {
        this.showInputTextModal = false;

        this.$emit('save', {
          name: this.queryName,
          dates: this.queryWithDates
        });
      } else {
        this.showInputTextModalError = true;
      }
    },
    onQueryWithDatesChanged (value) {
      this.queryWithDates = value;
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../stylesheets/variables.scss";

  .form-check {
    display: inline;
  }
</style>



// WEBPACK FOOTER //
// src/components/explorer/QuerySaveModal.vue